const componentWrapper = document.querySelector(".search-results");

if (componentWrapper) {
    const searchForm = componentWrapper.closest("form");
    const searchBar = document.querySelector(".search-results__searchbar");
    const clearSearch = document.querySelector(".search-results__clear");
    const sortOrder = document.querySelector(`[data-select="sort-order"]`);

    if (searchForm && searchBar && clearSearch) {
        searchForm.addEventListener("change", function ({ target }) {
            if (target.tagName.toLowerCase() === "select") {
                const name = target.querySelector(`[value="${ target.value }"]`).textContent;

                if (sortOrder) {
                    if (name.match(/z( |)-( |)a|z( |)to( |)a|new( |)to( |)old/i)) {
                        sortOrder.value = "1";
                        searchForm.submit();
                        return;
                    }

                    sortOrder.value = "0";
                }

                searchForm.submit();
            }
        });

        searchBar.addEventListener("input", function () {
            if (!!searchBar.value) {
                clearSearch.classList.remove("hidden");
            } else {
                clearSearch.classList.add("hidden");
            }
        });

        searchBar.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                searchBar.value = "";
                clearSearch.classList.add("hidden");
            }
        });

        clearSearch.addEventListener("click", function () {
            searchBar.value = "";
            clearSearch.classList.add("hidden");
        });
    }
}
